/**
 * Góp ý của nhân viên tiệm gửi SAPA (docs/plans/qr-sapa-va-nut-phan-hoi.md, ADR-107).
 *
 * MỘT nguồn cho ba nơi: DB (CHECK trong migration 0082), API (zod) và giao diện (chip + đếm ký tự).
 * Test tích hợp so từng phần tử với CHECK của DB (lesson 105) nên đổi ở đây mà quên DB sẽ đỏ.
 */
import { chuanHoaLoiNhan, LOI_NHAN_TOI_DA_DONG } from './loi-nhan.ts'
import { cheSoTrongChu } from './sdt.ts'

/** Nhóm góp ý. `khac` là mặc định khi người gửi không chọn — giao diện không hiện chip cho nó. */
export const LOAI_PHAN_HOI = ['kho-dung', 'loi', 'y-tuong', 'khen', 'khac'] as const
export type LoaiPhanHoi = (typeof LOAI_PHAN_HOI)[number]

/** Màn đang mở lúc bấm Góp ý (không phải đường dẫn thật — chỉ nhóm màn của web quầy). */
export const MAN_PHAN_HOI = [
  'lich',
  'danh-sach',
  'khach',
  'so-tien',
  'cua-toi',
  'cau-hinh',
] as const
export type ManPhanHoi = (typeof MAN_PHAN_HOI)[number]

/**
 * Góp ý của KHÁCH trong Mini App (mini-app-1-2-0, migration 0103): vào CHUNG bảng `phan_hoi` với cột `nguon = 'khach'`,
 * không danh tính (`created_by` NULL). Hai tập dưới đây là MỘT nguồn cho zod (API), chip (Mini App) và CHECK của DB;
 * `gop-y-khach.int.test` so từng phần tử với CHECK. Loại `'cua-hang'` chỉ của khách; quầy giữ `LOAI_PHAN_HOI`.
 */
export const LOAI_PHAN_HOI_KHACH = ['kho-dung', 'loi', 'cua-hang', 'khen', 'khac'] as const
export type LoaiPhanHoiKhach = (typeof LOAI_PHAN_HOI_KHACH)[number]
/** Màn khách đang mở lúc bấm Góp ý: trang cửa hàng hoặc "Của tôi" (của khách — khác "Việc của tôi" của quầy). */
export const MAN_PHAN_HOI_KHACH = ['cua-hang', 'cua-toi'] as const
export type ManPhanHoiKhach = (typeof MAN_PHAN_HOI_KHACH)[number]
/** Nguồn của một dòng `phan_hoi` (cột `nguon`, 0103). Dòng có từ trước 0103 đọc ra `'quay'`. */
export const NGUON_PHAN_HOI = ['quay', 'khach'] as const
export type NguonPhanHoi = (typeof NGUON_PHAN_HOI)[number]
/** Dạng số bản Mini App gửi kèm (`apps/miniapp/package.json` version): cùng luật với CHECK `phan_hoi_ban_ck` nhánh khách. */
export const PHAN_HOI_BAN_APP_RE = /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/
export function banAppHopLe(s: string): boolean {
  return PHAN_HOI_BAN_APP_RE.test(s)
}

/**
 * Hạn giữ góp ý (ngày) — job `phan-hoi.purge` xoá dòng cũ hơn mốc này. CON SỐ NÀY CŨNG NẰM CỨNG trong hàm DB
 * `don_phan_hoi_qua_han` (migration 0083, 4320 giờ): đổi thì cần migration MỚI; test `don-phan-hoi.int.test` giữ hai nơi khớp.
 */
export const HAN_GIU_PHAN_HOI_NGAY = 180
export const PHAN_HOI_TOI_DA_KY_TU = 500
export const PHAN_HOI_TOI_DA_DONG = LOI_NHAN_TOI_DA_DONG
/** Dạng mã bản web gửi kèm (mã băm ngắn của tệp JS): cùng luật với CHECK `phan_hoi_ban_ck`. */
export const PHAN_HOI_BAN_WEB_RE = /^[A-Za-z0-9_-]{1,40}$/
/** Mã bản web hợp lệ = đúng dạng VÀ không chứa dãy 9 chữ số trở lên (mã băm thật chỉ 8 ký tự; không để trường này giấu số điện thoại). */
export function banWebHopLe(s: string): boolean {
  return PHAN_HOI_BAN_WEB_RE.test(s) && !/\d{9}/.test(s)
}
/** Khổ màn (px) hợp lệ: cùng luật với CHECK `phan_hoi_kho_ck`. */
export const PHAN_HOI_KHO_MAN_TOI_THIEU = 200
export const PHAN_HOI_KHO_MAN_TOI_DA = 8000

/**
 * Chuẩn hoá chữ góp ý + CHE số điện thoại — chạy ở MÁY CHỦ trước khi lưu (chốt cuối); giao diện dùng
 * `chuanHoaLoiNhan` để đếm ký tự. Chữ tự do có thể chứa số của khách (NĐ 13/2023), nên số bị thay bằng `***`.
 * Trả `''` khi chỉ toàn khoảng trắng / ký tự ẩn. Idempotent.
 */
export function chuanHoaPhanHoi(vao: string): string {
  return cheSoTrongChu(chuanHoaLoiNhan(vao))
}
